import React from 'react';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import {
  BRAND_JOIN_LIST_FILTER_OPTION_MODEL,
  BRAND_JOIN_LIST_SORT_OPTION_MODEL,
} from '../../../../store/modules/brand/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { BRAND_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/brandConstants';
import columns from './columns';

const BrandJoinList = (props) => {
  const { brandJoinList, getList, getExcelDownload } = props;
  const { list, filterOption, sortOption, pagination, summary } = brandJoinList;

  return (
    <div className="account-permit-store-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: BRAND_JOIN_LIST_FILTER_OPTION_MODEL,
          sortOption: BRAND_JOIN_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={BRAND_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            ...utils,
          })
        }
      />
    </div>
  );
};

export default BrandJoinList;
